/**************************************************
 * Nombre:       Tarjeta_Local
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";
import {theme} from "../../Tema";
import {LocationOn, WhatsApp} from '@mui/icons-material'
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import {irMapa} from "../../Utilidades/irMapa";
import {iniciarChatWass} from "../../Utilidades/iniciarChatWass";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjeta_Local = ({izq, item}) => {
    const {sTab, sCell} = useResponsive()


    return (
        <Grid
            container
            direction={izq ? 'row' : 'row-reverse'}
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={sTab ? 4 : 12}
        >


            <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={0}
                    sx={{border: 4, borderRadius: 10, p: sCell ? 2 : 4}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                        <Typography
                            sx={{fontFamily: NEGRITA, fontSize: sCell ? 24 : 32, color: theme.palette.primary.main}}>
                            {item.nombre}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb: 2}}>
                        <Typography sx={{fontSize: 16, fontWeight: 500, textAlign: 'center', lineHeight: 1.3}}>
                            {item.descripcion}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontWeight: 600}}>
                            <span><LocationOn sx={{mt: 0.5, mb: -0.5}}/> </span> {item.direccion}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end'}}>
                        <Typography sx={{fontWeight: 600}}>
                            <span><WhatsApp sx={{mt: 0.5, mb: -0.5}}/> </span>{`+ 57 ${item.celular}`}
                        </Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}} spacing={2}>
                        <Button
                            onClick={() => irMapa({lat: item.lat, long: item.long})}
                        >Dirigeme</Button>
                        <Button
                            onClick={() => iniciarChatWass({numero: item.celular})}
                        >Escribir</Button>
                    </Grid>

                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start', px: 3}}>
                <Splide
                    //ref={refe}
                    aria-label="My Favorite Images" style={{width: '100%'}}
                    options={{
                        autoplay: true,
                        speed: 1500,
                        rewind: true,
                        perPage: 1,
                        arrows: true,
                        perMove: 1,
                        pagination: true,
                        width: '100%',
                        drag: 'free',
                        snap: true,
                        interval: 5000,
                        noDrag: true,
                        focus: 'center',
                        type: 'loop',
                        padding: '0rem',
                        gap: 20,

                    }}
                >

                    {item.fotos.map((item, index) => {
                        return (
                            <SplideSlide key={`qer${index}`}>
                                <img src={item} width={'100%'} height={'auto'}
                                     style={{borderRadius: 30, border: 10, borderColor: '#000'}}/>
                            </SplideSlide>
                        )
                    })}


                </Splide>


            </Grid>

        </Grid>
    )

}
export default Tarjeta_Local

const items = [1, 2, 3]